import React from 'react';
import { ParallaxLayer } from '@react-spring/parallax';
import './ParallaxSystem.css';
import { useTranslation } from 'react-i18next';

export const categoriesData = {
  fortunam_monteRosa_OAM: [
    { backgroundImage: '/assets/fortunam.jpg', modelName: 'fortunam' },
    { backgroundImage: '/assets/monteRosa.jpg', modelName: 'monteRosa' },
    { backgroundImage: '/assets/OAM.jpg', modelName: 'OAM' }, // Images en majuscules
  ],
  GTMR: [
    { backgroundImage: '/assets/GTMR_2.jpg', modelName: 'GTMR' },
    { backgroundImage: '/assets/GTMR_1.jpg', modelName: 'GTMR' },
  ],
  riviera: [
    { backgroundImage: '/assets/riviera_1.jpg', modelName: 'riviera' },
    { backgroundImage: '/assets/riviera_2.jpg', modelName: 'riviera' },
  ],
  fortunam: [
    { backgroundImage: '/assets/fortunam.jpg', modelName: 'fortunam' },
  ],
  monteRosa: [
    { backgroundImage: '/assets/monteRosa.jpg', modelName: 'monteRosa' },
  ],
  OAM: [
    { backgroundImage: '/assets/OAM.jpg', modelName: 'OAM' }, // Image en majuscule mais la clé de traduction sera en minuscule "oam"
  ],
};

export const Page = ({ offset, gradient, onClick, backgroundImage, modelName = 'GTMR', language = 'en', pageIndex }) => {
  const { t } = useTranslation();

  // Déterminer les clés de traduction pour chaque modèle
  let modelKey = modelName;

  if (modelName === 'GTMR') {
    modelKey = 'gtmr';
  } else if (modelName === 'riviera') {
    modelKey = 'seafront';
  } else if (modelName === 'OAM') {
    modelKey = 'oam'; // Utiliser "oam" en minuscule pour les traductions
  }

  // Récupérer les titres et descriptions
  const title =
    ['fortunam', 'monteRosa', 'oam'].includes(modelKey) // Vérifier si le modèle a un seul titre
      ? t(`design.${modelKey}.title`, { lng: language })
      : pageIndex === 0
      ? t(`design.${modelKey}.titleFirst`, { lng: language })
      : t(`design.${modelKey}.titleSecond`, { lng: language });

  const description =
    ['fortunam', 'monteRosa', 'oam'].includes(modelKey) // Utiliser le bon modèle
      ? Array.isArray(t(`design.${modelKey}.text`, { lng: language }))
        ? t(`design.${modelKey}.text`, { lng: language })[0] // Texte unique sous forme de tableau
        : t(`design.${modelKey}.text`, { lng: language })
      : pageIndex === 0
      ? Array.isArray(t(`design.${modelKey}.textFirst`, { lng: language }))
        ? t(`design.${modelKey}.textFirst`, { lng: language })[0]
        : t(`design.${modelKey}.textFirst`, { lng: language })
      : Array.isArray(t(`design.${modelKey}.textSecond`, { lng: language }))
        ? t(`design.${modelKey}.textSecond`, { lng: language })[0]
        : t(`design.${modelKey}.textSecond`, { lng: language });

  return (
    <>
      <ParallaxLayer offset={offset} speed={0} onClick={onClick}>
        <div className='slopeBegin' style={{ backgroundImage: `url(${backgroundImage})` }} />
      </ParallaxLayer>

      <ParallaxLayer offset={offset} speed={0.7} onClick={onClick}>
        <div className={`bandeauColor ${gradient}`}>
          <strong className="title">{title}</strong>
          <p className="description">{description}</p>
        </div>
      </ParallaxLayer>
    </>
  );
};